import React, { useContext, useState } from 'react'
import { Box } from '@mui/system'
import styled from '@emotion/styled' 
import { Alert, AlertTitle, Avatar, Button, Checkbox, FormControl, FormControlLabel, IconButton, InputAdornment, InputLabel, OutlinedInput, Snackbar, TextField, Typography } from '@mui/material'
import { useFormik } from "formik";
import {useNavigate,redirect, useLocation} from 'react-router-dom'
import * as yup from "yup";
import api from '../../api/authApi'
import useAuth from '../../hooks/useAuth'
import SetCookie from '../../hooks/setCookie'
import AuthContext from '../../context/AuthContext';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
const StyledForm=styled("form")(({theme})=>({
  padding:'20px',
  display:'flex',
  flexDirection:'column',
  gap:'20px',
}))
const BackGround=styled(Box)(({theme})=>({
   display:'flex',
   justifyContent:'center',
   alignItems:'center',
   padding:'30px',
   height:'100vh',
   width:'100vw',  
   background:theme.palette.secondary.lighter,
}))
const SignInCard=styled(Box)(({theme})=>({
    minWidth:'30%',
    minHeight:'75%',
    background:theme.palette.background.default,
    boxShadow: `0px 0px 7px ${theme.palette.background.shadow}`,
    borderRadius:'10px',
    padding:'10px',
    display:'flex',
    flexDirection:'column',
}))
const LogoContainer = styled('span')(({theme})=>({
    display: 'flex',
    gap: '5px',
    alignItems: 'center',
    justifyContent:'center',
    cursor:'pointer',
    span: {
        fontSize: '34px',
        fontWeight: '600',
    },
    marginLeft:'10px',
    paddingBottom:'40px',
    borderBottom: `0.5px solid ${theme.palette.third.light}`,
}))
const StyledTypography = styled(Box)(({theme})=>({
   display:'flex',
   width:'fit-content',
   justifyContent:'flex-end',
   textDecoration:'underline',
   marginLeft:'50%',
   cursor:'pointer',
   color:theme.palette.third.main,
   "&:hover":{
     color:theme.palette.secondary.main,

   }
}))

export default function SignIn() {
const {changed,setChanged}=useContext(AuthContext)
const navigate=useNavigate()
const location=useLocation()
const {user,setUser}=useAuth()
const [wrong,setWrong]=useState(false)
const [remember, setRemember]=useState(false);
const [visible, setVisible]=useState(false);
const validationSchema = yup.object({
  email: yup.string()
    .email("Enter the correct Email")
    .required("Email is required"),
  password: yup.string()
    .required("Password is required"),
});
const formik = useFormik({
    initialValues: {
      email:'',
      password:'',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const result={
          username:values.email,
          password:values.password,
        }
    try{
      const response=await api.post('login',result)
      // console.log(response.data)
      if(response.data==="Incorrect")
      {
        setWrong(true)
      }
      else{
          SetCookie('auth',JSON.stringify(response.data));
          setChanged((prev)=>!prev);
          const from=location.state?.from?.pathname || '/'
          navigate(from);
          window.location.reload();
      }
    }
     catch(err){
          console.error(err)
        }
    },
    
  });
  return (
    <BackGround>
        <SignInCard>
             <LogoContainer >
                <Avatar src="/images/aastulogo.png" sx={{ width: 40, height: 40 }} />
                <span>ASLMS</span>
            </LogoContainer>
            <StyledForm onSubmit={formik.handleSubmit}>
               <TextField
                fullWidth
                type="email"
                label="Email"
                id="email"
                name="email"
                onBlur={formik.handleBlur}
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.errors.email && formik.touched.email }
                helperText={formik.touched.email && formik.errors.email}
              />
              {/* <TextField
                fullWidth
                type="password"
                label="Password"
                id="password"
                name="password"
                value={formik.values.password}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                error={formik.errors.password && formik.touched.password }
                helperText={formik.touched.password && formik.errors.password}
              /> */}
              <FormControl variant="outlined">
                  <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                  <OutlinedInput
                    type={visible ? 'text' : 'password'}
                    fullWidth
                    id="password"
                    name="password"
                    value={formik.values.password}
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    error={formik.errors.password && formik.touched.password }
                    helperText={formik.touched.password && formik.errors.password}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                           onClick={()=>setVisible((prev)=>!prev)}
                          // onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {visible ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Password"
                  />
                </FormControl>
              {wrong && 
                  <Alert severity="error"  onClose={() => {setWrong(false)}}>
                    Incorrect Username or Password
                  </Alert>}
                <FormControlLabel control={<Checkbox
                    color='secondary' 
                    value={remember}
                    onChange={()=>setRemember(!remember)}
                    sx={{color:'third.main', }}
                    />} 
                    label="Remember me" 
            />
              <Button
               disabled={Boolean(formik.errors.email || formik.errors.password)}
              type="submit"
              size="large"
              sx={{
                   bgcolor:'secondary.main',
                   fontWeight: 400,
                   color:'#fff',
                  "&:hover":{
                   bgcolor:'secondary.hover',}, } }
              >
                Sign In
              </Button>
            </StyledForm>
            <StyledTypography onClick={()=>{navigate('/reset')}}>
              Forgot Your Password?
            </StyledTypography>
            <StyledTypography onClick={()=>{navigate('/new')}}>
              Sign Up
            </StyledTypography>
        </SignInCard>
        {/* <Snackbar open={wrong} autoHideDuration={6000} onClose={()=>setWrong(false)}>
            <Alert severity="error">Incorrect username or password</Alert>
        </Snackbar> */}
    </BackGround>
  )
}
